var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWoodRank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15H0.5V1H14.5V15Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 9.40001L5.16667 12.2L2.5 14.3M7.16667 9.40001C6.5 9.40001 5.83333 8.70001 5.83333 8.00001C5.83333 7.44001 6.5 6.60001 6.5 6.60001L8.5 5.90001M7.16667 9.40001L9.16667 8.70001M9.16667 8.70001L10.5 10.8L12.5 12.2L13.8333 12.9M9.16667 8.70001C9.16667 8.36129 9.25932 7.82589 9.16667 7.30001C9.06784 6.73911 8.77526 6.18904 8.5 5.90001M8.5 5.90001L11.8333 3.10001L13.8333 1.70001",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 6.6L13.8333 5.2M7.16667 5.9L6.5 1",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 8L3.16667 9.4L0.5 8.7",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16669 10.8C4.50002 11.5 7.30002 12.9 7.83335 12.9L11.1667 12.2L12.5 10.1V5.89999C11.8334 4.96666 10.3667 2.95999 9.83335 2.39999",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodRank);
export default __webpack_public_path__ + "static/media/wood_rank.64684521304bd7b3822feda8e61c0f55.svg";
export { ForwardRef as ReactComponent };